<cdx-slotted-modal
	*ngIf="loaded$ | async; else loading"
	verticalPadding="none"
	padding="none"
	(close)="close()"
	[mobileFullHeight]="true"
>
	<header modal-header>
		<h1 *cdxEmbedded="'hide'" i18n="@@addIngredientsModal-title">{{ title }}</h1>
		<p [ngClass]="{'embedded-spacing':isEmbeddedInApp}" *ngIf="servings">Serves {{ servings }}</p>
	</header>
	<div modal-content>
		<recipe-ingredient-grid
			*ngIf="ingredients?.length"
			title="You'll need..."
			gridType="main"
			[ingredients]="ingredients"
			[selectedSkus]="selectedSkus$ | async"
			(selectionsChanged)="handleMainSelectionChanges($event)"
			(quantityChanged)="handleQuantityChanged($event)"
		>
		</recipe-ingredient-grid>

		<recipe-ingredient-grid
			*ngIf="pantryItems?.length"
			title="You might already have..."
			gridType="pantry"
			[ingredients]="pantryItems"
			[selectedSkus]="selectedPantrySkus$ | async"
			(selectionsChanged)="handlePantrySelectionChanges($event)"
		>
		</recipe-ingredient-grid>
	</div>
	<footer modal-footer-primary>
		<div class="addToTrolley">
			<cdx-alert
				*ngIf="addToTrolleyNotification$ | async; let notification"
				[type]="notification.type"
				[title]="notification.message"
			>
			</cdx-alert>
			<button
				class="addToTrolley-button"
				cdxButton
				(click)="addToTrolley()"
				[buttonState]="buttonState$ | async"
				[disabled]="buttonDisabled$ | async"
				size="large"
			>
				Add to trolley
				<ng-container completed>Ingredients added to trolley</ng-container>
			</button>
		</div>
	</footer>
</cdx-slotted-modal>

<ng-template #loading>
	<cdx-slotted-modal (close)="close()">
		<cdx-wapple-loading modal-content></cdx-wapple-loading>
	</cdx-slotted-modal>
</ng-template>
